var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLaptop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M28.844 23.18h-18v-10h18z"
}), /*#__PURE__*/React.createElement("g", {
  stroke: "#464646",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.844 12.86a2 2 0 0 0-2-2h-18a2 2 0 0 0-2 2V25.5h22zM10.047 25.5H6.5v.458c0 1.404.93 2.542 2.077 2.542h22.846c1.147 0 2.077-1.138 2.077-2.542V25.5h-2.922"
})))));
export default SvgLaptop;